import { FunctionComponent, memo } from "react";
import { IProps } from "./filter-beta-warnings.types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import "./filter-beta-warnings.scss";

/**
 * Display any warnings for filters as group
 * @param props.formWarnings
 */
const FilterBetaWarnings: FunctionComponent<IProps> = ({ formWarnings }) => {
    return (
        <div className="filter-beta-warnings">
            {Object.entries(formWarnings).map(([warningType, warningMessage]) => (
                <div className="filter-beta-warnings__form-warning" key={warningType}>
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                    <span>{warningMessage}</span>
                </div>
            ))}
        </div>
    );
};

export default memo(FilterBetaWarnings);
